webpackJsonp([301],{

/***/ 1054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.3.6 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1869:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1054),
  /* template */
  __webpack_require__(2019),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.3.6-104.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.3.6-104.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09a47c79", Component.options)
  } else {
    hotAPI.reload("data-v-09a47c79", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2019:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.3.6 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support arrow less variables")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add slot:title")]), _vm._v(" "), _c('li', [_vm._v("[feature] Add prop:readonly")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix a bug caused by scroller #1406")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] render-function params day => date #1361")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:readonly")]), _vm._v(" "), _c('li', [_vm._v("[feature] Add slot:icon")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add method:setBlur")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/spinner.html"
    }
  }, [_vm._v("Spinner")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:size #1447")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/string.html"
    }
  }, [_vm._v("String")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] trim is now alias to stringTrim")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09a47c79", module.exports)
  }
}

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1869);

/***/ })

});


// WEBPACK FOOTER //
// 301.3ad5725a.js